define('dropdown-button',['controller', 'elements'], function(controller, elements) {
	function init(context) {
		var buttons = context.find('.dropdown-button');
		buttons.data('no-instant', true); // disable default click behaviour
		
		buttons.click(function(e){
			e.preventDefault(); // do not redirect
			
			var boxID = $(this).data('dropdown');
			var box = $('#' + boxID);
			box.toggleClass('open');
			var isOpen = box.hasClass('open');
			$(this).toggleClass('active', isOpen);
			$(this).triggerHandler(isOpen ? 'dropdown-open' : 'dropdown-close');
			
			// If there is a form, focus it
			if (isOpen) {
				// Without setTimeout, the input slides in after the box
				setTimeout(function() {
					box.find('input:not([type=hidden])').first().focus().select();
				}, 100);
			}
		});
	}
	
	$(document).click(function(e) {
		var target = $(e.target);
		$('.dropdown-button.active').each(function() {
			var boxID = $(this).data('dropdown');
			var box = $('#' + boxID);
			// If neither clicked on button, nor on box, close this box
			if (target.closest(box).length == 0 && target.closest($(this)).length == 0) {
				box.removeClass('open');
				$(this).removeClass('active');
			}
		});
	});
	
	elements.register(init);
});

